import { render, staticRenderFns } from "./TheTable.vue?vue&type=template&id=f5fb8636"
import script from "./TheTable.vue?vue&type=script&lang=js"
export * from "./TheTable.vue?vue&type=script&lang=js"
import style0 from "./TheTable.vue?vue&type=style&index=0&id=f5fb8636&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports